<div class="bl-text-align--center bl-margin-top--32">
  <span class="loading-results bl-text-align--center" [class.spinner-small]="spinnerSmall"></span>
</div>
